<template>
  <div class="flex justify-center flex-wrap">
    <!-- content section -->
    <div class="max-w-3xl m-2">
      <transition name="flip" mode="out-in">
        <div
          key="form"
          v-if="!submited"
          class="bg-white rounded-lg shadow-card p-8 sm:p-12"
        >
          <h1 class="font-semibold text-xl lg:text-2xl text-center">
            Provide your contact details and a BuildaBox.co CSR Professional
            will be in touch to discuss options
          </h1>

          <form class="mt-10" @submit.prevent="submitForm">
            <div class="mt-4 flex flex-col md:flex-row">
              <fieldset class="flex-1">
                <label for="first_name">First Name<small>*</small></label>
                <input
                  type="text"
                  class="input mt-2"
                  id="first_name"
                  name="first_name"
                  v-model="form.first_name"
                  required
                />
              </fieldset>
              <fieldset class="flex-1 mt-4 md:mt-0 ml-0 md:ml-4">
                <label for="last_name">Last Name<small>*</small></label>
                <input
                  type="text"
                  class="input mt-2"
                  id="last_name"
                  name="last_name"
                  v-model="form.last_name"
                  required
                />
              </fieldset>
            </div>

            <fieldset class="mt-4">
              <label for="name">Company Name<small>*</small></label>
              <input
                type="text"
                class="input mt-2"
                id="company_name"
                v-model="form.company_name"
                required
              />
            </fieldset>

            <div class="mt-4 flex flex-col md:flex-row">
              <fieldset class="flex-1">
                <label for="phone">Phone<small>*</small></label>
                <input
                  type="tel"
                  class="input mt-2"
                  id="phone"
                  name="phone"
                  v-model="form.phone"
                  required
                />
              </fieldset>

              <fieldset class="flex-1 mt-4 md:mt-0 ml-0 md:ml-4">
                <label for="email">Email<small>*</small></label>
                <input
                  type="tel"
                  class="input mt-2"
                  id="email"
                  name="email"
                  v-model="form.email"
                  required
                />
              </fieldset>
            </div>

            <fieldset class="mt-4">
              <label for="comment">Comment<small>*</small></label>
              <textarea
                class="textarea mt-2"
                id="comment"
                v-model="form.comment"
                required
              />
            </fieldset>

            <fieldset class="mt-16">
              <div class="flex flex-col-reverse sm:flex-row justify-between">
                <button
                  class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mt-5 sm:mt-0"
                  type="button"
                  @click="$emit('back')"
                >
                  <span>Back</span>
                </button>
                <button
                  class="btn btn-primary font-semibold rounded-lg px-10 min-w-10"
                  type="submit"
                  :disabled="!canSubmit"
                >
                  <span v-if="!progressSaving">Submit</span>
                  <Spinner class="mx-auto" v-if="progressSaving" />
                </button>
              </div>
            </fieldset>
          </form>
        </div>

        <!-- success message -->
        <div
          key="success"
          v-else
          class="max-w-4xl m-2 bg-white rounded-lg shadow-card p-8 sm:p-12"
        >
          <h2 class="font-semibold text-md sm:text-xl text-center">
            Thank you! A Success Manager will be in contact to discuss options
            for running your Corporate Social Responsibility Program through
            BuildaBox.co.
          </h2>

          <router-link :to="`/`">
            <button
              class="btn btn-primary font-semibold rounded-lg px-4 sm:px-16 mx-auto block mt-6"
            >
              Go to Home Page
            </button>
          </router-link>
        </div>
      </transition>
    </div>

    <!-- infobox -->
    <div class="m-2">
      <InfoBox class="mx-auto">
        The BuildaBox.co platform helps to streamline and automate powerful
        Corporate Social Responsibility (CSR) Programs. <br>Before this can be
        implemented it is critical to design the right CSR Program for your
        organization. <br> Our BuildaBox.co CSR Professionals will work with you to
        develop a Corporate Social Responsibility (CSR) Program that is perfect
        for your organization, develop pilot programs to refine the program and
        provide tangible assets for review and then implement the program
        through BuildaBox.co. <br>Complete the form and a BuildaBox.co CSR
        Professional will be in touch.
      </InfoBox>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/common/Spinner";
import Datepicker from "@/third-party/vuejs-datepicker/src/components/Datepicker";
import VueTimepicker from "@/third-party/vue2-timepicker/src/vue-timepicker";
import { required } from "vuelidate/lib/validators";
import Apiv1 from "@/api/api_v1.0.js";
import InfoBox from "../../../components/common/InfoBox.vue";

export default {
  name: "SegmentationCSRformStep",

  components: {
    Spinner,
    Datepicker,
    VueTimepicker,
    InfoBox
  },
  data() {
    return {
      submited: false,
      progressSaving: false,

      form: {
        first_name: "",
        last_name: "",
        company_name: "",
        phone: "",
        comment: "",
        email: ""
      }
    };
  },

  methods: {
    async submitForm() {
      this.progressSaving = true;
      await Apiv1.storeSegmentationCsrFormData(this.formattedFormData);
      this.progressSaving = false;
      this.submited = true;
    }
  },

  computed: {
    canSubmit() {
      return !this.$v.$invalid;
    },

    formattedFormData() {
      return {
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        company_name: this.form.company_name,
        phone: this.form.phone,
        email: this.form.email,
        comment: this.form.comment
      };
    }
  },

  validations: {
    form: {
      first_name: { required },
      last_name: { required },
      comment: { required },
      phone: { required },
      email: { required }
    }
  }
};
</script>
